import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";

@Injectable()
export class ConsultationEventManager {

  marquerCommeLu = new Subject();

  constructor() {
  }

  public onMarqueCommeLu() {
    return this.marquerCommeLu.asObservable();
  }

  public setmarquerCommeLu() {
    this.marquerCommeLu.next();
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/consultation/consultation.eventManger.ts